import adminAuthReducer from 'reducers/admin/adminAuthReducer';
import adminInvoiceReducer from 'reducers/admin/adminInvoiceReducer';
import adminOrdersReducer from 'reducers/admin/adminOrdersReducer.js';
import adminOrganisationsReducer from 'reducers/admin/adminOrganisationsReducer';
import adminOrgUsersReducer from 'reducers/admin/adminOrgUsersReducer';
import adminUsersReducer from 'reducers/admin/adminUsersReducer';
import batchesReducer from 'reducers/admin/batchesReducer';
import adminBundlesReducer from 'reducers/admin/bundlesReducer';
import dutiesReducer from 'reducers/admin/dutiesReducer';
import materialReducer from 'reducers/admin/materialReducer';
import orgIntegrationsReducer from 'reducers/admin/orgIntegrationsReducer';
import orgSuppliers from 'reducers/admin/orgSuppliersReducer';
import ratesReducer from 'reducers/admin/ratesReducer';
import shippersReducer from 'reducers/admin/shippersReducer';
import shippingReducer from 'reducers/admin/shippingReducer';
import skuReducer from 'reducers/admin/skuReducer';
import terminologyOrgReducer from 'reducers/admin/terminologiesReducer';
import trolliesReducer from 'reducers/admin/trolliesReducer';
import walletReducer from 'reducers/admin/walletReducer';
import warehouseReducer from 'reducers/admin/warehouseReducer';
import { combineReducers } from 'redux';
import { reduxTokenAuthReducer } from 'redux-token-auth';
import adminSalesAgentsReducer from './admin/adminSalesAgentsReducer';

export default combineReducers({
  reduxTokenAuth: reduxTokenAuthReducer,
  adminAuthReducer: adminAuthReducer,
  skuReducer: skuReducer,
  ratesReducer: ratesReducer,
  batchesReducer: batchesReducer,
  materialReducer: materialReducer,
  orgSuppliers: orgSuppliers,
  adminOrdersReducer: adminOrdersReducer,
  adminBundlesReducer: adminBundlesReducer,
  adminUsersReducer: adminUsersReducer,
  shippersReducer: shippersReducer,
  shippingReducer: shippingReducer,
  trolliesReducer: trolliesReducer,
  adminOrganisationsReducer: adminOrganisationsReducer,
  adminOrgUsersReducer: adminOrgUsersReducer,
  orgIntegrationsReducer: orgIntegrationsReducer,
  walletReducer: walletReducer,
  dutiesReducer: dutiesReducer,
  warehouseReducer: warehouseReducer,
  terminologyOrgReducer: terminologyOrgReducer,
  adminInvoiceReducer: adminInvoiceReducer,
  adminSalesAgentsReducer: adminSalesAgentsReducer,
});
